import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/films/{id}/members — film members. */
export function useFilmMembers(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.filmMembers(filmId),
    queryFn: ({ signal }) => apiGet(`/films/${filmId}/members`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
